import baseAPI from "@/http";

const router = "api/seloClienteOcultoPerguntasComentarios";

export const seloClienteOcultoPerguntasComentariosAPI = {
  add: (arquivos) => baseAPI.post(`${router}`, arquivos),
  atualizar: (resposta) => baseAPI.put(`${router}`, resposta),
  delete: (perguntaComentarioId) =>
    baseAPI.delete(`${router}/${perguntaComentarioId}`),
  get: (perguntaComentarioId) =>
    baseAPI.get(`${router}/${perguntaComentarioId}`),
  list: () => baseAPI.get(`${router}`),
};
